export default __webpack_public_path__ + "static/media/rocketbuy-logo.40bb3b24.svg";